import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { StatusModel } from '@models/types'

import useStatus from '@hooks/useStatus'

const Status = (props: { status: StatusModel }) => {
  const { status } = props
  const { id, title } = status

  const useStatusPayload = useStatus(status)
  const { callbacks: { editStatus } } = useStatusPayload

  return (
    <DashboardModuleListItem
      onClick={() => editStatus()}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default Status
